<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="k-rtl">
      <!-- کارت‌های آمار بار کاربر -->
      <div class="row px-3 pt-2 md-pt-0 md-px-0">
        <div class="col-lg-3">
          <div class="widget home style1" style="background: #FFEFE7">
            <div class="row">
              <div class="col-4">
                <div class="main-card__icon-container">
                  <i class="fas fa-bullhorn fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد کل بار‌های شما </span>
                <h1 class="font-bold main-card__data">
                  {{ dashboard.all_request }}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="widget home style1">
            <div class="row">
              <div class="col-4">
                <div class="main-card__icon-container">
                  <i class="fas fa-dove fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد بارهای آزاد </span>
                <h2 class="font-bold main-card__data">
                  {{ dashboard.today_free_request }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="widget home style1">
            <div class="row">
              <div class="col-4">
                <div class="main-card__icon-container">
                  <i class="fas fa-handshake fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد بار در انتظار حمل </span>
                <h2 class="font-bold main-card__data">
                  {{ dashboard.today_reserve_request }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="widget home style1">
            <div class="row">
              <div class="col-4">
                <div class="main-card__icon-container">
                  <i class="fas fa-truck-moving fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد بار در انتظار تحویل </span>
                <h2 class="font-bold main-card__data">
                  {{ dashboard.today_wait_for_delivery_request }}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- نمودار بارهای کاربر -->
      <bita-ibox>
        <div slot="body">
          <div class="k-rtl">
            <chart
              :key="chartKey"
              v-if="chart.length > 0"
              :chart-data="chart"
              y-title="تعداد بار گرفته شده"
              category="created_at"
              value="count"
              height="500px"
            />
          </div>
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
import Chart from "../components/template/chart/AmColumnWithRoutatedSeries";

export default {
  name: "UserDashboard",
  components: { Chart },
  data() {
    return {
      dashboard: {},
      chartKey: 0,
      chart: [],
    };
  },
  mounted() {
    this.$setLayout("app-layout");
    this.getDashboardData();
  },
  methods: {
    getDashboardData() {
      this.$persistClient("get", "dashboard").then((res) => {
        const rawData = res.data.data.last_request;
        this.chart = rawData.map((data) => ({
          ...data,
          created_at: this.$getJalaliDateFromDateTime(data.created_at),
        }));
        this.dashboard = res.data.data;
        this.chartKey++;
      });
    },
  },
};
</script>

<style scoped>
.main-card__data {
  font-weight: 900;
  font-size: 40px !important;
  margin: 10px 0 !important;
  position: absolute;
  bottom: -30px;
}
.ibox {
  margin-top: 17px;
}
</style>